import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './jobsdashboard.css';


function AddJob({ job, setJob })
{
    const navigate = useNavigate();

    const handleChange = (e) =>
    {
        setJob({
            ...job,
            [e.target.name]: e.target.value,
        });
    };

    const handleNext = () =>
    {
        navigate('/add-job/add-job-02');
    };

    return (
        <div className="add-job">
            <h2>Create a New Job</h2>
            <div>
                <label>Job Name</label>
                <input
                    type="text"
                    name="jobtitle"
                    value={job.jobtitle}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Job Description</label>
                <textarea
                    name="description"
                    value={job.description}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Postcode</label>
                <input
                    type="text"
                    name="postcode"
                    value={job.postcode}
                    onChange={handleChange}
                    required
                />
            </div>
            <button onClick={handleNext}>Next</button>
        </div>
    );
}

export default AddJob;